﻿window.lstPop = [];
window.$DivSignaleCorbeille = null
window.mGetDataTemplate = function (bddRef,idTable,id, funcOk) {
    bddRef.mAjaxCall({ command: "getlstdatavirtualgrid", data: [{ id_table: idTable, id: id }], lst_id_champ_table: "" }, function (data) {
        funcOk(data.lstdatatemplate[0])
    })
}
window.cObjet = function (data, id, bddRef, idHistoSupp) {
    var Me = this;
    this.bddRef = bddRef; //((typeof bddRef == "undefined") ? bdd : bddRef);
    this.id_historique_sup = idHistoSupp

    this.mGetData = function (id, async, funcOk) {
        var data = null;
        if (typeof idHistoSupp == 'undefined' && typeof this.bddRef.mGetArray(Me.nomTable) != 'undefined' && this.bddRef.mGetArray(Me.nomTable) != null) {
            data = this.bddRef.mGetArray(Me.nomTable).filterFirst(function (o) { return o["id_" + Me.nomTable] == id })[0]
            if (funcOk) funcOk(data, Me.bdd)
        }
        if (data == null) {
            if (!data) {
                //if (idHistoSupp == 1186) debugger;
                var dataToBeSend = { command: "getdata", nomtable: this.nomTable, id: id, async: async }
                if (typeof idHistoSupp != 'undefined') { dataToBeSend.idHistoSupp = idHistoSupp } else { dataToBeSend.idHistoSupp = -1 }
                Me.bddRef.mAjaxCall(dataToBeSend, function (data) {
                    Me.data = data[Me.nomTable];
                    if (typeof Me.data != 'undefined') Me.nomCle = Object.keys(Me.data)[0]
                    if (funcOk) funcOk(Me.data, Me.bdd)
                    data = Me.data
                });
            } else {
                if (funcOk) funcOk(data, Me.bdd)
            }
        } else { Me.Data = data; }
        return data
    }

    if ((typeof data === 'string' || data instanceof String) && data.isNumeric()) {
        //on a un id_table
        this.nomTable = Me.bddRef.table.mGetItem(data).nom;
        this.id = id;
        this.nomCle = "id_" + this.nomTable
        if (typeof id != 'undefined' && id != null) {
            if (typeof idHistoSupp != 'undefined') {
                //on veut charger un élément de la corbeille
                //il n'est pas en mémoire
                //on le charge du serveur
                this.mGetData(this.id, false)
            } else {
                if (Me.bddRef.mGetArray(this.nomTable) != null) {
                    this.data = Me.bddRef.mGetArray(this.nomTable).filterFirst(function (o) { return o[Me.nomCle] == id; })[0]
                    if (this.data == 'undefined') {
                        //les données ne sont pas encore en mémoire
                        this.mGetData(this.id, false)
                    }
                } else { this.mGetData(this.id, false) }
            }
        }
    } else if (typeof data === 'string' || data instanceof String) {
        if (data == 'fichier') {
            this.nomTable = data;
            if (typeof id != 'undefined') {
                this.nomCle = "id_" + this.nomTable
                if (typeof id === 'string' || id instanceof String) {
                    data = { id_fichier: id }
                    this.id = id;
                } else {
                    data = id;
                    this.id = data.id_fichier;
                }
                this.data = data
            }
        } else {
            this.nomTable = data;
            this.id = id;
            this.nomCle = "id_" + this.nomTable
            if (typeof id != 'undefined' && id != null) {
                if (Me.bddRef.mGetArray(this.nomTable) != null) {
                    this.data = Me.bddRef.mGetArray(this.nomTable).filterFirst(function (o) { return o[Me.nomCle] == id; })[0]
                    if (typeof this.data == 'undefined') {
                        //les données ne sont pas encore en mémoire
                        this.mGetData(this.id, false)
                    }
                } else {
                    this.mGetData(this.id, false)
                }
            }
        }
    }
    else {
        this.data = data;
        this.nomCle = Object.keys(data)[0]
        this.id = data[this.nomCle];
        this.nomTable = this.nomCle.substring(3)
    }

    this.setPersistance = function (nomVar, value, option) {
        mInitPersistance()
        if (typeof option == 'undefined') { this.bddRef.persistance[this.nomTable][this.cle()][nomVar] = value }
        else {
            if (typeof this.bddRef.persistance[this.nomTable][this.cle()][nomVar] == 'undefined') this.bddRef.persistance[this.nomTable][this.cle()][nomVar] = []
            var variable = this.bddRef.persistance[this.nomTable][this.cle()][nomVar].filterFirst(function (o) {
                var ok = true
                for (var prop in option) {
                    if (prop != "value" && option[prop] != o[prop]) ok = false
                }
                return ok;
            })[0]
            if (typeof variable == 'undefined') {
                option.value = value
                this.bddRef.persistance[this.nomTable][this.cle()][nomVar].push(option)
            }
            else { variable.value = value }
        }
    }
    this.getPersistance = function (nomVar, option) {
        mInitPersistance()
        if (typeof option == 'undefined') { return this.bddRef.persistance[this.nomTable][this.cle()][nomVar] }
        else {
            if (typeof this.bddRef.persistance[this.nomTable][this.cle()][nomVar] == 'undefined') this.bddRef.persistance[this.nomTable][this.cle()][nomVar] = []
            var variable = this.bddRef.persistance[this.nomTable][this.cle()][nomVar].filterFirst(function (o) {
                var ok = true
                for (var prop in option) {
                    if (prop != "value" && option[prop] != o[prop]) ok = false
                }
                return ok;
            })[0]
            if (typeof variable == 'undefined') { return variable } else { return variable.value }
        }
    }
    this.deletePersistance = function (nomVar, option) {
        mInitPersistance()
        if (typeof option == 'undefined') { if (typeof this.bddRef.persistance[this.nomTable][this.cle()][nomVar]) delete this.bddRef.persistance[this.nomTable][this.cle()][nomVar] }
        else {
            if (typeof this.bddRef.persistance[this.nomTable][this.cle()][nomVar] == 'undefined') this.bddRef.persistance[this.nomTable][this.cle()][nomVar] = []
            var variable = this.bddRef.persistance[this.nomTable][this.cle()][nomVar].filterFirst(function (o) {
                var ok = true
                for (var prop in option) {
                    if (prop != "value" && option[prop] != o[prop]) ok = false
                }
                return ok;
            })[0]
            if (typeof variable != 'undefined') { this.bddRef.persistance[this.nomTable][this.cle()][nomVar].splice(this.bddRef.persistance[this.nomTable][this.cle()][nomVar].indexOf(variable), 1) }
        }
    }
    function mInitPersistance() {
        if (typeof Me.bddRef.persistance == 'undefined') Me.bddRef.persistance = {}
        if (typeof Me.bddRef.persistance[Me.nomTable] == 'undefined') Me.bddRef.persistance[Me.nomTable] = []
        if (typeof Me.bddRef.persistance[Me.nomTable][Me.cle()] == 'undefined') Me.bddRef.persistance[Me.nomTable][Me.cle()] = {}
    }

    this.nomElementTache = function () {
        if (this.nomTable == "fichier") {
            if (this.data.id_fichier.startsWith(".")) { return this.data.id_fichier.substring(1) }
            else { return this.data.id_fichier.substring(this.data.id_fichier.lastIndexOf(".") + 1) }
        } else {
            return this.nomTable
        }
    }

    this.mGetData64Image = function (funcOk,async) {
        Me.bddRef.mAjaxCall({
            command: "getimageobjet",
            id_table: Me.mGetTable().id_table,
            id: Me.cle(),
            async:async
        }, function (data) {
            funcOk(data.data64img)
        }, null, function () {
            funcOk("")
        })
    }

    this.mGetUrlImage = function () {
        return bddRef.repertoireImageTable.substring(1) + "/" + this.nomTable + "/" + this.cle() + ".png"
    }

    this.isNew = function () {
        if (this.nomTable == "fichier") {
            if (this.data.id_fichier.startsWith(".")) { return true }
            else { return false }
        } else {
            return (this.id == null)
        }
    }

    this.mGetTable = function () {
        return Me.bddRef.table.mGetItemFromNom(this.nomTable);
    }

    this.cle = function () {
        if (typeof this.data == 'undefined') { return this.data }
        else { return this.data[Object.keys(this.data)[0]] }
    }

    this.mGetLibBase = function () {
        if (this.objetMetier) { return this.objetMetier.mGetLibBase(); }
        else { return this.nomTable }
    }
    this.mGetAttributBase = function () {
        if (this.objetMetier) { return ((typeof this.objetMetier.mGetAttributBase() == 'undefined') ? "" : this.objetMetier.mGetAttributBase()); }
        else { return "" }
    }

    this.mGetNewLib = function () {
        return this.objetMetier.mGetNewLib();
    }

    this.mGetLib1 = function (option) {
        if (this.objetMetier) {
            return this.objetMetier.mGetLib1(option);
        }
        else { return this.data.nom }
    }
    this.mGetLib2 = function () {
        return this.objetMetier.mGetLib2();
    }
    this.mGetLibCourt = function (nb) {
        if (typeof nb == 'undefined') nb = 20
        return this.mGetLib1().substring(0, 20) + ((this.mGetLib1().length > nb) ? "..." : "")
    }
    this.mGetPrefixeNom = function () {
        if (this.objetMetier && typeof this.objetMetier.mGetPrefixeNom != 'undefined') { return this.objetMetier.mGetPrefixeNom(); }
        return ""
    }
    this.mGetIcone = function (dataTemplate) {
        if (typeof dataTemplate == 'undefined') dataTemplate = this.data
        if (this.objetMetier) { return this.objetMetier.mGetIcone(dataTemplate); }
        else { return $("<i/>"); }
    }
    this.mGetImageData = function (opt) {
        if (this.objetMetier && typeof this.objetMetier.mGetImageData != "undefined") { return this.objetMetier.mGetImageData(opt); }
        else { return $("<div/>").dxCtrlImageData(opt).dxCtrlImageData("instance") }

    }
    this.mGetRadiusImage = function () {
        return this.objetMetier.mGetRadiusImage();
    }
    this.mGetResume = function () {
        return this.objetMetier.mGetResume();
    }

    // Si suppression, l'itemData a été supprimé (call mRemoveItem(itemData)
    // sinon, si l'itemData n'est pas nuul, alors on modifie uniquement l'itemdata (call mMajItem(itemData))
    //        sinon si l'itemdata est null, on met à jour toute la grille (call mMajItem())
    this.mMajPage = function (itemData, suppression) {
        if (this.objetMetier && typeof this.objetMetier.mMajPage != 'undefined') { this.objetMetier.mMajPage(itemData, suppression); }
        if ($("body").find(".dx-ctrlgridhistorique").getInstance()) $("body").find(".dx-ctrlgridhistorique").getInstance().mReload();
    }

    this.isChanged = false;

    this.itemTemplate = function (contentElement, option) {
        if (this.objetMetier && typeof this.objetMetier.itemTemplate != 'undefined') { return this.objetMetier.itemTemplate(contentElement, option); }
        else {
            contentElement.css("text-align", "left");
            contentElement.css("padding-left", "0");
            var $Table = $("<table style='width:100%'/>").appendTo(contentElement);
            var $Tr = $("<tr/>").appendTo($Table);
            var $Td = $("<td style='width:1px'/>").appendTo($Table);
            this.mGetIcone().appendTo($Td)
            var $Td = $("<td style='width:100%;vertical-align:middle;padding-left:5px;'>" + Me.mGetLib1() + "</td>").appendTo($Table);
        }
    }
    this.urlImageObjet = function () {
        return "/fichier/img/" + me.mGetTable().nom + "/" + Me.cle() +""
    }

    this.mGetItemTemplateHeight = function (type) {
        if (this.objetMetier != null && typeof this.objetMetier.mGetItemTemplateHeight != 'undefined') { return this.objetMetier.mGetItemTemplateHeight(type) }
        else {
            switch (this.mGetTable().nom) {
                case "contact": case "structures": case "structures_contact": case "compte_client": case "compte_client_utilisateur":
                    return ((type == "Détails") ? 100 : 57)
                    break;
                default:
                    return ((type == "Détails") ? 65 : 45)
                    break;
            }
        }
    }
    this.mGetDataTemplate = function (lstIdChampTableString, funcOk) {
        bddRef.mAjaxCall({ command: "getlstdatavirtualgrid", data: [{ id_table: Me.mGetTable().id_table, id: Me.cle() }], lst_id_champ_table: lstIdChampTableString }, function (data) {
            funcOk(data.lstdatatemplate[0])
        })
    }
    this.mGetNomFromTemplate = function (dataTemplate) {
        if (this.objetMetier != null && typeof this.objetMetier.mGetNomFromTemplate != 'undefined') { return this.objetMetier.mGetNomFromTemplate(dataTemplate) }
        else { return dataTemplate.nom }
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        var lstIdChampTableString = ""
        if (typeof option != 'undefined' && typeof option.dataGridVue != 'undefined' && option.dataGridVue != null) {
            lstIdChampTableString = bddRef.getObjet(option.dataGridVue).objetMetier.mGetLstIdChampTableString((option.onChange == 'undefined' || option.onChange == null) && (option.onChanged == 'undefined' || option.onChanged == null))
        }
        if (typeof option == 'undefined') option = {}
        if (typeof dataTemplate == 'undefined' || dataTemplate == null) {
            this.mGetDataTemplate(lstIdChampTableString, function (dataTemplate) {
                Me.itemTemplateGrille(contentElement, dataTemplate, type, option)
            })
        } else {
            if (this.objetMetier && typeof this.objetMetier.itemTemplateGrille != 'undefined') {
                return this.objetMetier.itemTemplateGrille(contentElement, dataTemplate, type, option);
            }
            else {
                switch (this.mGetTable().nom) {
                    case "contact": case "structures": case "structures_contact": case "compte_client": case "compte_client_utilisateur":
                        itemTemplateGridStrCon()
                }
            }
        }

        function itemTemplateGridStrCon() {
            var lstIdChampTableString = ""
            if (typeof option != 'undefined' && typeof option.dataGridVue != 'undefined' && option.dataGridVue != null) {
                lstIdChampTableString = bddRef.getObjet(option.dataGridVue).objetMetier.mGetLstIdChampTableString((option.onChange == 'undefined' || option.onChange == null) && (option.onChanged == 'undefined' || option.onChanged == null), option.typeDisplay)
            }
            if (typeof dataTemplate == 'undefined' || dataTemplate == null) {
                Me.mGetDataTemplate(lstIdChampTableString, function (newDataTemplate) {
                    dataTemplate = newDataTemplate
                    mConstruitTemplate()
                })
            } else { mConstruitTemplate() }

            function mConstruitTemplate() {
                contentElement.empty()
                if (typeof option == 'undefined') option = {}
                if (typeof option.isForTagBoxEmail == 'undefined') option.isForTagBoxEmail = false
                if (typeof option.isForTagBoxSms == 'undefined') option.isForTagBoxSms = false

                if ((typeof option.dataGridVue == "undefined")) {// || Me.mGetTable().nom == "compte_client" || Me.mGetTable().nom == "compte_client_utilisateur") {
                    var fieldStrCon = new cFieldStrCon(bddRef)
                    fieldStrCon.mConstruitResumeDetail(contentElement, dataTemplate, type, option)
                } else {
                    //on a un dataGridVue sur str/strcon/con
                    var opt = {
                        bddCtrl: bddRef,
                        dataGridVue: option.dataGridVue,
                        fields: option.fields,
                        dataTemplate: dataTemplate,
                        onChange: option.onChange,
                        typeDisplay: option.typeDisplay
                    }
                    $("<div/>").appendTo(contentElement).dxCtrlGridTemplateDisplay(opt)
                }

            }
        }
    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus, option) {
        if (this.objetMetier && typeof this.objetMetier.itemTemplateGrillePlus != 'undefined') { return this.objetMetier.itemTemplateGrillePlus(contentElement, dataPlus); }
        else {
            switch (this.mGetTable().nom) {
                case "contact": case "structures": case "structures_contact": case "compte_client": case "compte_client_utilisateur":
                    itemTemplateGrillePlus()
            }
        }

        function itemTemplateGrillePlus() {
            if (dataPlus.dcr.toDateIlya(true) == dataPlus.dmo.toDateIlya(true)) {
                var $S = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
                $S.attr("title", "Créé le " + dataPlus.dcr.toFrenchDateTime())
            } else {
                var $S = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "<br/><i class='fas fa-pen dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dmo.toDateIlya(true) + "</span>").appendTo(contentElement)
                $S.attr("title", "Créé le " + dataPlus.dcr.toFrenchDateTime() + "<br/>Modifié le " + dataPlus.dmo.toFrenchDateTime())
            }
            var $SpanClickVue = $("<span/>").appendTo(contentElement)
            if (dataPlus.dcr_lastdatevue != null) {
                var $S = $("<br/><span><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>(" + dataPlus.nb_vue + ") " + dataPlus.dcr_lastdatevue.toDateIlya(true) + "</span>").appendTo($SpanClickVue)
                $S.attr("title", "Dernière vue le " + dataPlus.dcr_lastdatevue.toFrenchDateTime())
            }
            if (dataPlus.dcr_lastdateclick != null) {
                var $S = $("<br/><span><i class='fas fa-arrow-pointer dx-theme-accent-as-text-color' style='padding-right:3px;'></i>(" + dataPlus.nb_click + ") " + dataPlus.dcr_lastdateclick.toDateIlya(true) + "</span>").appendTo($SpanClickVue)
                $S.attr("title", "Dernier click le " + dataPlus.dcr_lastdateclick.toFrenchDateTime())
            }
        }
    }

    this.mShowNew = function (optionValue, optionPopup) {
        if (typeof optionValue == "undefined" || !optionValue) optionValue = {};
        if (typeof optionPopup == "undefined" || !optionPopup) optionPopup = {};
        if (this.objetMetier && typeof this.objetMetier.mShowNew != 'undefined') { return this.objetMetier.mShowNew(optionValue, optionPopup); }
        else {
            var newData = this.mGetNewData(optionValue)
            var pop = Me.bddRef.getObjet(newData).mShowPopup(optionPopup);
            return pop;
        }
    }
    this.mGetNewData = function (optionValue) {
        var newData = JSON.clone(Me.bddRef.schemaBdd[this.nomTable])
        for (var prop in newData) {
            if (newData[prop] && newData[prop] == "popsoftgetdate") newData[prop] = new Date()
        }
        if (this.objetMetier && typeof this.objetMetier.mInitNewData != 'undefined') this.objetMetier.mInitNewData(newData);
        if (typeof newData.dcr != 'undefined' && newData.dcr == null) newData.dcr = new Date();
        if (typeof newData.dmo != 'undefined' && newData.dmo == null) newData.dmo = ((typeof newData.dcr != 'undefined' && newData.dcr == null) ? new Date() : newData.dcr);
        newData[Me.nomCle] = null;
        //if (this.mGetTable().nom == 'utilisateur' && Me.bddRef.mGetArray("societe") != null &&
        //    Me.bddRef.mGetArray("societe").filter(function (o) { return o.date_abandon == null }).length > 0) {
        //    newData.id_societe_defaut = Me.bddRef.mGetArray("societe").filter(function (o) { return o.date_abandon == null })[0].id_societe
        //}
        if (typeof optionValue == "undefined" || !optionValue) optionValue = {};
        for (var prop in optionValue) {
            if (typeof newData[prop] != 'undefined') newData[prop] = optionValue[prop]
        }
        return newData
    }

    this.mGetPopup = function (pop, newObjet, optionPopup) {
        var result = null;
        if (typeof pop.objet.data[Me.nomCle] != 'undefined' &&
            ((typeof newObjet.data != 'undefined' && typeof newObjet.data[Me.nomCle] != 'undefined' &&
                pop.objet.data[Me.nomCle] == newObjet.data[Me.nomCle] && pop.objet.mGetTable().nom == newObjet.mGetTable().nom) ||
                (typeof newObjet.data == 'undefined' && newObjet.id == pop.objet.data[Me.nomCle] && newObjet.mGetTable().nom == pop.objet.mGetTable().nom))) {
            if (pop.objet.objetMetier && typeof pop.objet.objetMetier.mGetPopup != 'undefined') {
                result = pop.objet.objetMetier.mGetPopup(pop, newObjet, optionPopup)
            }
            else { result = pop }
        }
        return result;
    }

    //this.mGetDatas = function (funcOk, getRelation, sql) {
    //    Me.bddRef.mAjaxCall({ command: "getdatas", nomtable: Me.nomTable, getrelation: getRelation, sql: sql }, function (data) {
    //        if (typeof data[Me.nomTable] == 'undefined') data[Me.nomTable] = [];
    //        if (typeof funcOk != 'undefined') funcOk(data[Me.nomTable]);
    //    });
    //}

    //SAUVEGARDE L'ENSEMBLE DE L'OBJET
    this.mSave = function (funcOk, funcAlways, funcKo, async, option) {
        if (typeof option == "undefined" || option == null) option = {}
        if (this.nomTable == "fichier") { this.objetMetier.mSave(funcOk, funcAlways, funcKo, async, option) }
        else {
            var isNew = (typeof this.cle() == 'undefined' || this.cle() == null)
            var stack = { stack: mGetStackTrace() }
            if (this.objetMetier && typeof this.objetMetier.mSaveBefore != 'undefined') this.objetMetier.mSaveBefore()
            if (this.objetMetier && typeof this.objetMetier.mSaveBeforeBloquant != 'undefined') {
                this.objetMetier.mSaveBeforeBloquant(function () { mSave(); })
            } else { mSave(); }

            function mSave() {
                mNettoieWarning()
                if (Me.data[Me.nomCle] == null && Me.nomTable != "utilisateur" && (typeof Me.data.id_utilisateur == 'undefined' || Me.data.id_utilisateur == null) && Me.mGetTable().nom != "support_ticket") {
                    Me.data.id_utilisateur = Me.bddRef.utiCourant.id_utilisateur
                }
                Me.bddRef.mAjaxCall({ command: "saveobjet", nomtable: Me.nomTable, objet: Me.data, async: ((async) ? async : true) }, function (data) {
                    //Me.bddRef.mMaj(data.bdd)
                    var dataObjet = Me.data
                    if (typeof data.text_erreur != 'undefined' && data.text_erreur.length > 0) {
                        mNotify(data.text_erreur, "error", 6000)
                        if (Me.bddRef.hasStore(Me.nomTable)) Me.bddRef.mDelItemData(Me.nomtable, Me.data)
                    } else {
                        //if (typeof data.nom != 'undefined') Me.data.nom = data.nom;
                        for (var prop in data) {
                            if (prop.startsWith("newvalue_")) Me.data[prop.replace("newvalue_", "")] = data[prop];
                        }
                        if (Me.data[Me.nomCle] == null) {
                            Me.data[Me.nomCle] = data.id;
                            //Me.data.id_arbo = Me.mGetTable().id_table + "_" + Me.data[Me.nomCle]
                            if (Me.bddRef.hasStore(Me.nomTable)) {
                                Me.bddRef.mAddItemData(Me.nomTable, Me.data)
                                dataObjet = bddRef.mGetArray(Me.nomTable).filter(function (o) { return o[Me.nomCle] == data.id })[0]
                            } else {
                                if (!option.disableTriggerModif) Me.bddRef.triggerFunctionOnModifiedStore(Me.nomTable)
                            }
                        }
                        else {
                            //Me.data.id_arbo = Me.mGetTable().id_table + "_" + Me.data[Me.nomCle]
                            if (Me.bddRef.hasStore(Me.nomTable)) {
                                if (Me.bddRef.mGetArray(Me.nomTable).filter(function (o) { return o[Me.nomCle] == Me.data[Me.nomCle] }).length == 0) {
                                    Me.bddRef.mAddItemData(Me.nomTable, Me.data)
                                }
                                else { Me.bddRef.mMajItemData(Me.nomTable, Me.data) }
                                dataObjet = bddRef.mGetArray(Me.nomTable).filter(function (o) { return o[Me.nomCle] == data.id })[0]
                            } else {
                                if (!option.disableTriggerModif) Me.bddRef.triggerFunctionOnModifiedStore(Me.nomTable)
                            }
                        }
                        if (!option.disableTriggerModif) Me.bddRef.triggerFunctionOnModifiedItemData(Me.nomTable, ((isNew) ? "new" : "modif"), Me.data)
                        if (typeof mClearPersistance != 'undefined') mClearPersistance(((isNew) ? "new" : "modif"), Me.data)
                    }
                    if (funcOk) funcOk(data, dataObjet)
                    if (Me.objetMetier && typeof Me.objetMetier.mActionSaveAfter != 'undefined') {
                        Me.objetMetier.mActionSaveAfter()
                    }
                },
                    function () { if (funcAlways) funcAlways() },
                    function () { if (funcKo) funcKo() });
            }
        }
    }
    this.mUpdateViaTrigger = function () {
        Me.bddRef.triggerFunctionOnModifiedItemData(Me.nomTable, "modif", Me.data)
    }

    //SAUVEGARDE UN CHAMP DE L'OBJET
    this.mSaveChamp = function (nomChamp, funcOk, option,async = true) {
        if (this.data[this.nomCle] == null || typeof nomChamp == 'undefined' || nomChamp == null || nomChamp.length == 0) {
            this.mSave(funcOk);
        } else {
            if (this.objetMetier && typeof this.objetMetier.mSaveBeforeBloquant != 'undefined') {
                this.objetMetier.mSaveBeforeBloquant(function () { mSaveChamp(); }, nomChamp)
            } else { mSaveChamp(); }
            function mSaveChamp() {
                mNettoieWarning()
                var stack = { stack: mGetStackTrace() }
                Me.bddRef.mAjaxCall({
                    command: "savechamp",
                    nomtable: Me.nomTable,
                    nomchamp: nomChamp,
                    valuechamp: Me.data[nomChamp],
                    idkey: Me.data[Me.nomCle],
                    async: async,
                    option: option
                }, function (data) {
                    if (Me.data[Me.nomCle] == null) {
                        Me.data[Me.nomCle] = data.id;
                    }
                    if (Me.bddRef.hasStore(Me.nomTable)) {
                        Me.bddRef.mMajItemData(Me.nomTable, Me.data)
                    } else {
                        Me.bddRef.triggerFunctionOnModifiedStore(Me.nomTable)
                    }
                    Me.bddRef.triggerFunctionOnModifiedItemData(Me.nomTable, "modif", Me.data, nomChamp)
                    if (typeof mClearPersistance != 'undefined') mClearPersistance("modif", Me.data, nomChamp)
                    if (funcOk) funcOk(data)
                    if (Me.objetMetier && typeof Me.objetMetier.mActionSaveAfter != 'undefined') {
                        Me.objetMetier.mActionSaveAfter()
                    }
                },
                    function () { },
                    function () {
                    });
            }
        }
    }

    function mNettoieWarning() {
        if (Me.nomTable == "compte_email" && typeof Me.bddRef.utiCourantParaJson.warning != 'undefined' &&
            typeof Me.bddRef.utiCourantParaJson.warning.email != 'undefined') {
            Me.bddRef.utiCourantParaJson.warning.email["idcompte_email_" + Me.data.id_compte_email] = {}
        }
    }

    this.mHasTabPopup = function () {
        if (this.objetMetier && typeof this.objetMetier.mHasTabPopup != 'undefined') { return this.objetMetier.mHasTabPopup(); }
        else { return true }
    }
    this.mGetPopupPositionWidthHeight = function () {
        if (typeof Me.bddRef.utiCourantParaJson.popupsize == 'undefined') Me.bddRef.utiCourantParaJson.popupsize = {}
        if (typeof Me.bddRef.utiCourantParaJson.popupsize[this.mGetTable().nom] != 'undefined') {
            switch (this.mGetTable().nom) {
                case "structures": case "structures_contact":
                    return bddRef.utiCourantParaJson.popupsize["structures"]
                    break;
                default:
                    return bddRef.utiCourantParaJson.popupsize[this.mGetTable().nom]
                    break;
            }
        } else {
            if (this.objetMetier && typeof this.objetMetier.mGetPopupPositionWidthHeight != 'undefined') { return this.objetMetier.mGetPopupPositionWidthHeight(); }
            else {
                return {
                    width: "650",
                    maxWidth: "calc(100% - 60px)",
                    height: "calc(100% - 90px)",
                    maxHeight: "calc(100% - 50px)",
                    position: {
                        my: "right top",
                        at: "right top",
                        of: "body",
                        offset: { x: -30, y: 65 }
                    }
                }
            }
        }
    }
    this.mSavePopupPositionWidthHeight = function (width, height) {
        if (typeof Me.bddRef.utiCourantParaJson.popupsize == 'undefined') Me.bddRef.utiCourantParaJson.popupsize = {}
        var popupPositionWidthHeight = this.mGetPopupPositionWidthHeight()
        popupPositionWidthHeight.width = width
        popupPositionWidthHeight.height = height
        switch (this.mGetTable().nom) {
            case "structures": case "structures_contact":
                bddRef.utiCourantParaJson.popupsize["structures"] = popupPositionWidthHeight
                break;
            default:
                bddRef.utiCourantParaJson.popupsize[this.mGetTable().nom] = popupPositionWidthHeight
                break;
        }
        bddRef.mSaveParaJsonUtilisateur();
    }
    this.mGetDisplayInPopup = function (newValue) {
        if (this.objetMetier && typeof this.objetMetier.mGetDisplayInPopup != 'undefined') {
            return this.objetMetier.mGetDisplayInPopup(newValue);
        } else {
            if (typeof bddRef.utiCourantParaJson["dataDisplayInPopup_" + this.mGetTable().nom] == 'undefined') {
                bddRef.utiCourantParaJson["dataDisplayInPopup_" + this.mGetTable().nom] = false
            }
            if (typeof newValue != 'undefined') {
                bddRef.utiCourantParaJson["dataDisplayInPopup_" + this.mGetTable().nom] = newValue
                bddRef.mSaveParaJsonUtilisateur();
            }
            return bddRef.utiCourantParaJson["dataDisplayInPopup_" + this.mGetTable().nom]
        }
    }

    //SUPPRIME L'OBJET
    this.mDelDataDefinitif = function (funcOk, option, funcAlways, funcKo) {
        this.mDelData(funcOk, option, true, null, funcAlways, funcKo, true)
    }
    this.mDelData = function (funcOk, option, noRestore, funcRestore, funcAlways, funcKo, defintif) {
        if (this.objetMetier && typeof this.objetMetier.mDelData != 'undefined') {
            //if (this.nomTable == "fichier" && typeof Me.data.id_fichier == 'undefined') Me.data.id_fichier = Me.data.id
            this.objetMetier.mDelData(funcOk, option, noRestore, funcRestore, funcAlways, funcKo, defintif)
        } else { this.mDelDataInterne(funcOk, option, noRestore, funcRestore, funcAlways, funcKo, defintif) }
    }
    this.mDelDataInterne = function (funcOk, option, noRestore, funcRestore, funcAlways, funcKo, defintif) {
        if (typeof option == "undefined" || option == null) option = {}
        if (this.nomTable == "fichier") {
            //if (typeof Me.data.id_fichier == 'undefined') Me.data.id_fichier = Me.data.id
            this.objetMetier.mDelData(funcOk, option, noRestore, funcRestore, funcAlways, funcKo)
        } else {
            if (typeof this.id != 'undefined' && this.id != null) {
                var introDel = ""
                if (typeof noRestore == 'undefined' || !noRestore) introDel = Me.mGetAttributBase() + Me.mGetLibBase() + ((typeof Me.data != 'undefined') ? " <i>" + Me.mGetLib1() + "</i>" : "")
                var dataToBeSent = { command: ((defintif) ? "deletedefinitivement" : "deldanshistorique"), nomtable: Me.nomTable }
                dataToBeSent.timeout = option.timeout
                dataToBeSent.objet = {}
                dataToBeSent.objet["id_" + Me.nomTable] = Me.id;
                mNettoieWarning()
                //var timeOutJauge = window.setTimeout(function () { jaugeDemarrage.mShow() },800)
                Me.bddRef.mAjaxCall(dataToBeSent, function (data) {
                    //window.clearTimeout(timeOutJauge)
                    //jaugeDemarrage.mHide()
                    if (typeof noRestore == 'undefined' || !noRestore) {
                        if ($DivSignaleCorbeille) $DivSignaleCorbeille.hide()
                        $DivSignaleCorbeille = notify.mShow({
                            width: 320,
                            showTitle: false,
                            message: function (contentElement, popup) {
                                contentElement.closest(".popupcontent").css("padding", "10px")
                                contentElement.css("font-size", "100%")
                                contentElement.css("padding-left", "10px")
                                var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                                var $Tr = $("<tr/>").appendTo($Table)
                                var $TdMessage = $("<td style='white-space:nowrap;padding-right:5px;text-align:right;'>L'objet a été mis à la corbeille</td>").appendTo($Tr)
                                var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                                $("<div/>").appendTo($Td).dxCtrlButton({
                                    icon: "fas fa-trash-restore",
                                    txtTooltip: "Restaurer l'élément de la corbeille",
                                    width: 40,
                                    onClick: function (e) {
                                        popup.hide()
                                        mRestore(data.id_historique);
                                    }
                                })
                            },
                            tempoSeconde: 4
                        });
                    }
                    if (data.histo_del) data.histo_del.forEach(function (histo) {
                        if (typeof histo.id == 'undefined' && histo.id == null) debugger;
                        if (Me.bddRef.mGetArray(histo.nomtable) != null) {
                            var itemData = Me.bddRef.mGetArray(histo.nomtable).filterFirst(function (o) { return o["id_" + histo.nomtable] == histo.id })[0]
                            if (Me.bddRef.hasStore(histo.nomtable)) { Me.bddRef.mDelItemDataWithId(histo.nomtable, histo.id) } else { Me.bddRef.triggerFunctionOnModifiedStore(histo.nomtable) }
                            if (typeof mClearPersistance != 'undefined') mClearPersistance("supp", Me.data)
                            if (!option.disableTriggerModif) Me.bddRef.triggerFunctionOnModifiedItemData(histo.nomtable, "supp", itemData)
                        }
                    });
                    if (data.lstDelDefintif) data.lstDelDefintif.forEach(function (delDef) {
                        var nomTable = Me.bddRef.table.mGetItem(delDef.id_table).nom
                        if (Me.bddRef.mGetArray(nomTable)) {
                            var itemData = Me.bddRef.mGetArray(nomTable).filterFirst(function (o) { return o["id_" + nomTable] == delDef.id })[0]
                            if (Me.bddRef.hasStore(nomTable)) { Me.bddRef.mDelItemDataWithId(nomTable, delDef.id) }
                            else { Me.bddRef.triggerFunctionOnModifiedStore(nomTable) }
                            Me.bddRef.triggerFunctionOnModifiedItemData(nomTable, "supp", itemData)
                        } else {
                            Me.bddRef.triggerFunctionOnModifiedStore(nomTable)
                        }
                    })
                    if (!option.disableTriggerModif && Me.bddRef.mGetArray(Me.nomTable) == null) Me.bddRef.triggerFunctionOnModifiedItemData(Me.nomTable, "supp", Me.data)
                    if (data.histo_maj) data.histo_maj.forEach(function (histo) {
                        if (Me.bddRef.mGetArray(histo.nomtable) != null) {
                            var itemData = Me.bddRef.mGetArray(histo.nomtable).filter(function (o) { return o["id_" + histo.nomtable] == histo.id })[0]
                            if (typeof itemData != 'undefined') {
                                itemData[histo.idmaj] = null;
                                if (Me.bddRef.hasStore(Me.nomTable)) { Me.bddRef.mMajItemData(histo.nomtable, itemData) } else { Me.bddRef.triggerFunctionOnModifiedStore(Me.nomTable) }
                                if (!option.disableTriggerModif) Me.bddRef.triggerFunctionOnModifiedItemData(histo.nomtable, "modif", itemData)
                            }
                        }
                    });
                    if (funcOk) funcOk(Me.id)
                    if (Me.objetMetier && typeof Me.objetMetier.mActionSaveAfter != 'undefined') {
                        Me.objetMetier.mActionSaveAfter()
                    }
                },
                    function () { },
                    function () {
                    });
            }
            else {
                var nbBoucleNull = 0
                var func = function () {
                    if (Me.data[Me.nomCle] == null || Me.data[Me.nomCle].length == 0) {
                        nbBoucleNull += 1
                        if (nbBoucleNull < 10) { window.setTimeout(function () { func(); }, 100); }
                        else {
                            //a priori, n'existe pas dans la base
                            if (typeof funcOk != 'undefined') funcOk(Me.data)
                        }
                    } else {
                        var introDel = ""
                        if (typeof noRestore == 'undefined' || !noRestore) introDel = Me.mGetAttributBase() + Me.mGetLibBase() + ((typeof Me.data != 'undefined') ? " <i>" + Me.mGetLib1() + "</i>" : "")
                        Me.bddRef.mAjaxCall({ command: "deldanshistorique", nomtable: Me.nomTable, objet: Me.data, old_val: Me.mGetLib1(), option: option }, function (data) {
                            if (typeof noRestore == 'undefined' || !noRestore) {
                                mNotify(introDel + " a été mis à la corbeille. Si vous avez fait une erreur, <b>cliquez pour restaurer l'élément de la corbeille</b>.", "warning", 15000, function () {
                                    mRestore(data.id_historique);
                                })
                            }
                            Me.mMajFromHisto(data)
                            if (funcOk) funcOk(data)
                            if (Me.objetMetier && typeof Me.objetMetier.mActionSaveAfter != 'undefined') {
                                Me.objetMetier.mActionSaveAfter()
                            }
                        },
                            function () { },
                            function () {
                            });
                    }
                }
                func();
            }

            function mRestore(idHistorique) {
                jaugeDemarrage.mShow()
                Me.bddRef.restore(idHistorique, function () { jaugeDemarrage.mHide() }, function () { jaugeDemarrage.mHide() }, false)
            }
        }
    }

    this.mMajFromHisto = function (data) {
        if (data.histo_del) data.histo_del.forEach(function (histo) {
            if (typeof histo.id == 'undefined' && histo.id == null) debugger;
            if (Me.bddRef.hasStore(histo.nomtable)) { Me.bddRef.mDelItemDataWithId(histo.nomtable, histo.id) } else { Me.bddRef.triggerFunctionOnModifiedStore(histo.nomtable) }
            Me.bddRef.triggerFunctionOnModifiedItemData(histo.nomtable, "supp", Me.data)
            if (typeof mClearPersistance != 'undefined') mClearPersistance("supp", Me.data)
        });
        if (data.histo_maj) data.histo_maj.forEach(function (histo) {
            if (Me.bddRef.mGetArray(histo.nomtable) != null) {
                var itemData = Me.bddRef.mGetArray(histo.nomtable).filterFirst(function (o) { return o[histo.idmaj] == histo.id })[0]
                if (typeof itemData != 'undefined') {
                    itemData[histo.idmaj] = null;
                    if (Me.bddRef.hasStore(histo.nomtable)) { Me.bddRef.mMajItemData(histo.nomtable, itemData) } else { Me.bddRef.triggerFunctionOnModifiedStore(histo.nomtable) }
                }
            }
        });
    }

    this.mAddData = function (funcOk) {
        Me.bddRef.mAjaxCall({ command: "adddata", nomtable: this.nomTable, objet: this.data }, function (data) {
            if (Me.data[Me.nomCle] == null) {
                Me.data[Me.nomCle] = data.id;
            }
            if (funcOk) funcOk(data)
        },
            function () { },
            function () {
            });
    }

    this.mGetClassImg = function () { return "img_" + this.nomTable + "_" + this.cle(); }

    this.mGetCtrlFichierForPopup = function () {
        if (this.objetMetier && typeof this.objetMetier.mGetCtrlFichierForPopup != 'undefined') { return this.objetMetier.mGetCtrlFichierForPopup(); }
        else { return null; }
    }

    this.lstDateForImage = []
    this.mReinitDateForImage = function () { this.lstDateForImage[this.nomTable] = null; }
    this.mGetDateForImage = function () {
        if (typeof this.lstDateForImage[this.nomTable] == 'undefined' || !this.lstDateForImage[this.nomTable]) this.lstDateForImage[this.nomTable] = (new Date).getTime();
        return this.lstDateForImage[this.nomTable];
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
        if (this.objetMetier && typeof this.objetMetier.contentTemplateGrid != 'undefined') { return this.objetMetier.contentTemplateGrid(contentElement, option); }
    }

    this.hasScrollPopup = function () {
        var result = false
        if (Me.objetMetier && typeof Me.objetMetier.hasScrollPopup != 'undefined') result = Me.objetMetier.hasScrollPopup();
        return result
    }
    this.contentTemplatePopup = function (contentElement, optionPopup) {
        var result = null
        if (Me.objetMetier && typeof Me.objetMetier.contentTemplatePopup != 'undefined') {
            result = Me.objetMetier.contentTemplatePopup(contentElement, optionPopup);
        }
        return result
    }

    this.mGetDetail = function (contentElement, titleElementIco, titleElementCmd, titleElementLib) {
        return this.objetMetier.mGetDetail(contentElement, titleElementIco, titleElementCmd, titleElementLib);
    }

    // POPUP
    this.mShowPopup = function (optionPopup) {
        if (typeof this.data.id_historique_sup != 'undefined' && this.data.id_historique_sup != null) {
            mNotify("Cet élément est dans votre corbeille.<br/><a href='javascript:void(0)'>Cliquez pour le restaurer</a>", "warning", 6000, function () {
                bddRef.restore(Me.data.id_historique_sup, function (data) {
                    //bddRef.getObjet(Me.mGetTable().nom, Me.data["id_" + Me.mGetTable().nom]).mShowPopup()
                }, function () {
                    mNotify("Une erreur s'est produite durant la restauration. Impossible de restaurer l'élément.", "error", 6000)
                }, false)
            })
        } else {
            if (this.objetMetier && typeof this.objetMetier.mShowPopup != 'undefined') { return this.objetMetier.mShowPopup(optionPopup); }
            else {
                if (typeof optionPopup == 'undefined') optionPopup = {}
                if (typeof optionPopup.fullScreen == 'undefined') {
                    if (typeof bddRef.utiCourantParaJson.para_popup == 'undefined') bddRef.utiCourantParaJson.para_popup = {}
                    if (typeof bddRef.utiCourantParaJson.para_popup[this.mGetTable().nom] == 'undefined') bddRef.utiCourantParaJson.para_popup[this.mGetTable().nom] = {}
                    if (typeof bddRef.utiCourantParaJson.para_popup[this.mGetTable().nom] == 'undefined') {
                        bddRef.utiCourantParaJson.para_popup[this.mGetTable().nom].fullScreen = ((typeof this.objetMetier.isPopupFullScreen == 'undefined') ? true : this.objetMetier.isPopupFullScreen)
                    }
                    bddRef.mSaveParaJsonUtilisateur();
                    optionPopup.fullScreen = bddRef.utiCourantParaJson.para_popup[this.mGetTable().nom].fullScreen
                }
                page.mAddPopup(this.data, optionPopup)
            }
        }
    }

    this.mShowPopupInterne = function (optionPopup) {
        if (typeof this.data != 'undefined' && typeof this.data.id_historique_sup != "undefined" && this.data.id_historique_sup != null) {
            //l'objet est supprimé
            //on propose de le restaurer
            notify.mShow({
                son: "info",
                message: function (contentElement, popup) {
                    $("<div style='padding:0 10px 10px 10px;'>L'éléments que vous voulez afficher se trouve dans la corbeille.<br/>Vous devez le restaurez de la corbeille pour pouvoir l'afficher.</div>").appendTo(contentElement)
                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                        icon: 'fas fas-trash-restore',
                        text: "Restaurer l'élément",
                        onClick: function (e) {
                            Me.bddRef.mAjaxCall({ command: 'restorefromhistorique', id_table: Me.bddRef.table.mGetItemFromNom(Me.nomTable).id_table, id: Me.cle() },
                                function (data) {
                                    //Me.bddRef.mMaj(data.bdd)
                                    var nomTable = Me.bddRef.table.mGetItem(data.id_table).nom
                                    var dataObjet = Me.bddRef.mGetArray(nomTable).filterFirst(function (o) { return o["id_" + nomTable] == data.id })[0]
                                    if (typeof dataObjet != 'undefined') {
                                        Me.bddRef.getObjet(dataObjet).mShowPopup(optionPopup);
                                    } else { mNotify("Impossible de restaurer l'élément", "warning", 6000); }
                                })
                            popup.hide();
                        }
                    });
                },
                titre: "Eléments dans la corbeille",
                img: "<i class='fas fa-exclamation-triangle' style='font-size:30px'/>",
                tempoSeconde: 10
            });
            return;
        }
        var trouver = null;
        if (!this.isNew()) {
            lstPop.forEach(function (popp) {
                if (!trouver) {
                    trouver = Me.mGetPopup(popp, Me, optionPopup)
                    if (trouver) {
                        popp.show();
                        popp.bringToFront()
                    }
                }
            });
        }
        if (trouver) return trouver;
        if (typeof optionPopup == 'undefined') optionPopup = {};
        if (typeof optionPopup.shading == 'undefined') {
            if (this.objetMetier && typeof this.objetMetier.shading != 'undefined') { optionPopup.shading = this.objetMetier.shading; }
            else { optionPopup.shading = true; }
        }

        var dataSourceTab = [{
            id: 'detail',
            text: "Détail",
            icon: "",
            contentTemplate: function (contentElement) {
                optionPopup.onChangeTitle = function () { pop.titleElementLib.text((!Me.data[Me.nomCle]) ? "(" + Me.mGetNewLib() + ")" : Me.mGetLib1()); }
                var func = function () {
                    if (typeof Me.data == 'undefined') {
                        mNotify("L'élément que vous voulez afficher n'existe plus.", "warning", 10000)
                        pop.hide();
                    } else {
                        optionPopup.pop = pop;
                        Me.contentTemplatePopup(contentElement, optionPopup);
                    }
                }
                if (Me.data == null) {
                    Me.mGetData(Me.id, false, function () { func(); })
                } else { func(); }
            }
        }]
        if (Me.objetMetier && typeof Me.objetMetier.getDataSourceTab != 'undefined') dataSourceTab = dataSourceTab.concat(Me.objetMetier.getDataSourceTab());
        if (typeof optionPopup.hasTabHistorique != 'undefined' || optionPopup.hasTabHistorique) {
            dataSourceTab.push({
                id: 'historique',
                text: "Historique",
                icon: "fas fa-history",
                contentTemplate: function (contentElement) {
                }
            })
        }

        //if (this.objetMetier && typeof this.objetMetier.mShowPopup != 'undefined') { return this.objetMetier.mShowPopup(option); }
        var pop = $("<div/>").appendTo("body").dxCtrlPopupObjet({
            bddCtrl: Me.bddRef,
            shading: optionPopup.shading,
            onDelete: optionPopup.onDelete,
            position: optionPopup.position,
            fullScreen: optionPopup.fullScreen,
            disableScroll: optionPopup.disableScroll,
            showMaximize: optionPopup.showMaximize,
            titleEmpty: optionPopup.titleEmpty,
            width: ((parametre.isPhone) ? "100%" : ((typeof optionPopup.width != 'undefined') ? optionPopup.width : (($("body").innerWidth() < 800) ? "100%" : 800))),
            minWidth: ((parametre.isPhone) ? 0 : 600),
            height: ((optionPopup.shading) ? "100%" : "calc(100% - " + heightBarreTache + "px)"),
            onTitleCmdTemplate: optionPopup.onTitleCmdTemplate,
            onHidden: function (e) {
                if (Me.objetMetier && typeof Me.objetMetier.mOnHiddenPopup != 'undefined') { Me.objetMetier.mOnHiddenPopup(); }
                lstPop.splice(lstPop.indexOf(pop), 1);
                if (typeof optionPopup.onHidden != 'undefined') optionPopup.onHidden(e)
            },
            datasourceTab: dataSourceTab,
            onContentReady: function (e) {
                if (!optionPopup.shading && typeof page.dxCtrlBarreTache != 'undefined' && page.dxCtrlBarreTache) page.dxCtrlBarreTache.addBtTache(pop, Me.nomTable);
            },
            onHiding: optionPopup.onHiding,
            onReady: function (component, funcEndLoad) {
                var func = function () {
                    if (typeof Me.data == 'undefined' || Me.data == null) {
                        window.setTimeout(function () { func(); }, 50);
                    } else {
                        //pop.objet = new cObjet(Me.data);
                        if (typeof optionPopup.titleEmpty == 'undefined' || !optionPopup.titleEmpty) {
                            Me.mGetIcone().css({ "max-width": "46px", "max-height": "46px" }).appendTo(pop.titleElementIco);
                            pop.titleElementLib.text(((typeof optionPopup.titleLib != 'undefined') ? optionPopup.titleLib : (!Me.data[Me.nomCle]) ? "(" + Me.mGetNewLib() + ")" : Me.mGetLib1()));
                        } else { component.element().find(".dx-popup-title").css("border-bottom", "none") }
                        if (typeof funcEndLoad != 'undefined') funcEndLoad();
                        if (typeof optionPopup.titleEmpty == 'undefined' || !optionPopup.titleEmpty) {
                            if (Me.objetMetier && typeof Me.objetMetier.contentTemplateCmdPopup != 'undefined') { Me.objetMetier.contentTemplateCmdPopup(pop, pop.titleElementCmd, optionPopup); }
                        }
                        if (typeof funcEndLoad != 'undefined') funcEndLoad();
                        if (typeof optionPopup.onContentTemplate != 'undefined') {
                            optionPopup.onContentTemplate(pop.contentElement, pop, function () {
                                window.setTimeout(function () {
                                    if (pop.dxScrollViewContent) pop.dxScrollViewContent.update();
                                    if (component.jauge) component.jauge.mHide(250);
                                    if (typeof funcEndLoad != 'undefined') funcEndLoad();
                                    if (typeof optionPopup.onReady != 'undefined') optionPopup.onReady();
                                }, 750);
                                pop.itemData = Me.data;
                                lstPop.push(pop);
                            });
                        } else {
                            window.setTimeout(function () {
                                if (pop.dxScrollViewContent) pop.dxScrollViewContent.update();
                                if (component.jauge) component.jauge.mHide(250);
                                if (typeof funcEndLoad != 'undefined') funcEndLoad();
                                if (typeof optionPopup.onReady != 'undefined') optionPopup.onReady();
                            }, 750);
                            pop.itemData = Me.data;
                            lstPop.push(pop);
                        }
                    }
                }
                func();
            }
        }).dxCtrlPopupObjet("instance");
        pop.objet = Me;
        pop.show();
        return pop;
    }

    function mNomTableToNomObjetJs() {
        var nomTableJs = Me.nomTable;
        nomTableJs = nomTableJs[0].toUpperCase() + nomTableJs.substring(1)
        while (nomTableJs.contains("_")) {
            var n1 = nomTableJs.substring(0, nomTableJs.indexOf("_"))
            var n2 = nomTableJs.substring(nomTableJs.indexOf("_") + 1)
            nomTableJs = n1 + n2[0].toUpperCase() + n2.substring(1)
        }
        return nomTableJs
    }

    this.mInitNewNom = function () {
        if (this.objetMetier && typeof this.objetMetier.mInitNewNom != 'undefined') { return this.objetMetier.mInitNewNom(); }
        else {
            if (Me.bddRef.mGetArray(this.nomTable)) {
                var idx = 1
                while (Me.bddRef.mGetArray(this.nomTable).filterFirst(function (o) { return o.nom == Me.mGetLibBase() + " (" + idx + ")" }).length > 0) { idx += 1 }
                this.data.nom = this.mGetLibBase() + " (" + idx + ")"
            }
            else {
                Me.bddRef.mAjaxCall({ command: "getnewnom", nomtable: this.nomTable, libbase: this.mGetLibBase(), async: false }, function (data) {
                    Me.data.nom = data.nom;
                })
            }
        }
    }
        ;
    this.objetMetier = null;
    if (typeof window["cObjet" + mNomTableToNomObjetJs() + "Metier"] != 'undefined') {
        if (Me.nomTable == "fichier") {
            if (typeof Me.data == 'undefined') {
                this.objetMetier = new window["cObjet" + mNomTableToNomObjetJs() + "Metier"](Me, bddRef);
            } else {
                this.objetMetier = new window["cObjet" + mNomTableToNomObjetJs() + "Metier"](Me.data, bddRef);
            }
        } else { this.objetMetier = new window["cObjet" + mNomTableToNomObjetJs() + "Metier"](Me); }
    }

    this.mGetUrlFileFichierTable = function (nomIdFichierTable) {
        if (data[nomIdFichierTable] != null) {
            var dataFichierTable = Me.bddRef.getObjet("fichier_table", data[nomIdFichierTable]).data
            return "/Fichier/" + Me.bddRef.nom_base + "/bdd/fichier_table/" + dataFichierTable.id_fichier_table + "/" + dataFichierTable.nom
        } else { return "" }
    }
    this.mGetElementIconeLib = function () {
        var $Span = $("<span/>")
        this.mGetIcone().appendTo($Span)
        $("<span style='padding-left:5px;'>" + this.mGetLib1() + "</span>").appendTo($Span)
        return $Span
    }
    this.mGetShowTitlePopup = function () {
        if (typeof this.objetMetier == 'undefined' || this.objetMetier == null) { return true }
        else if (typeof this.objetMetier.mGetShowTitlePopup == 'undefined') { return true }
        else { return this.objetMetier.mGetShowTitlePopup() }
    }
    this.mGetWidthPopup = function () {
        if (typeof this.objetMetier == 'undefined' || this.objetMetier == null) { return 800 }
        else if (typeof this.objetMetier.mGetWidthPopup == 'undefined') { return 800 }
        else { return this.objetMetier.mGetWidthPopup() }
    }
    this.mGetFullScreenPopup = function () {
        if (typeof this.objetMetier == 'undefined' || this.objetMetier == null) { return false }
        else if (typeof this.objetMetier.mGetFullScreenPopup == 'undefined') { return false }
        else { return this.objetMetier.mGetFullScreenPopup() }
    }
    this.mGetPaddingPopup = function () {
        if (typeof this.objetMetier == 'undefined' || this.objetMetier == null) { return 5 }
        else if (typeof this.objetMetier.mGetPaddingPopup == 'undefined') { return 5 }
        else { return this.objetMetier.mGetPaddingPopup() }
    }

    return this;
}

window.mGetLibFromDataTemplateStrCon = function(bddRef,dataTemplateStrCon,nbReduit,sautDeLigne) {
    switch (bddRef.table.mGetItem(dataTemplateStrCon.id_table_key).nom) {
        case "structures":
            return ((typeof dataTemplateStrCon.nom_str != 'undefined' && dataTemplateStrCon.nom_str != null) ?
                ((typeof nbReduit == 'undefined') ? dataTemplateStrCon.nom_str : dataTemplateStrCon.nom_str .reduit(nbReduit)) : "")
            break;
        case "contact":
            var nomPrenom = new cNomPrenom(bddRef)
            var lib = nomPrenom.mGetDisplayMiseEnForme(dataTemplateStrCon.con_nom, dataTemplateStrCon.con_prenom, dataTemplateStrCon.id_titre)
            lib = ((typeof nbReduit == 'undefined') ? lib : lib.reduit(nbReduit))
            return lib
            break;
        case "structures_contact":
            var nomStr = ((typeof dataTemplateStrCon.nom_str != 'undefined' && dataTemplateStrCon.nom_str != null) ?
                ((typeof nbReduit == 'undefined') ? dataTemplateStrCon.nom_str : dataTemplateStrCon.nom_str.reduit(nbReduit)) : "")
            var nomPrenom = new cNomPrenom(bddRef)
            var lib = nomPrenom.mGetDisplayMiseEnForme(dataTemplateStrCon.con_nom, dataTemplateStrCon.con_prenom, dataTemplateStrCon.id_titre)
            lib = ((typeof nbReduit == 'undefined') ? lib : lib.reduit(nbReduit))
            return nomStr + ((sautDeLigne) ? "<br/>" : " / ") + lib
            break;
    }
}